import { defineComponent as r, ref as a, openBlock as l, createElementBlock as s, renderSlot as u, pushScopeId as c, popScopeId as d, createElementVNode as n } from "vue";
import { _ as p } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseShimmerLoader.css';const m = (e) => (c("data-v-e0e7ce0a"), e = e(), d(), e), _ = /* @__PURE__ */ m(() => /* @__PURE__ */ n("div", { class: "shimmer uikit-absolute uikit-bottom-0 uikit-left-0 uikit-right-0 uikit-top-0 uikit-h-full -uikit-translate-x-full" }, null, -1)), f = /* @__PURE__ */ r({
  __name: "BaseShimmerLoader",
  setup(e, { expose: o }) {
    const t = a(null);
    return o({
      el: t
    }), (i, k) => (l(), s("div", {
      ref_key: "el",
      ref: t,
      class: "uikit-relative uikit-overflow-hidden uikit-bg-w-lavender"
    }, [
      _,
      u(i.$slots, "default", {}, void 0, !0)
    ], 512));
  }
}), S = /* @__PURE__ */ p(f, [["__scopeId", "data-v-e0e7ce0a"]]);
export {
  S as default
};
